import React, { useRef, useMemo } from 'react'
import { useFrame, useLoader } from '@react-three/fiber'
import * as THREE from 'three'
import { CardWithPosition } from './utils'

interface CardProps {
  card: CardWithPosition;
  isMobile: boolean;
}

export const Card: React.FC<CardProps> = ({ card, isMobile }) => {
  const meshRef = useRef<THREE.Mesh>(null)
  const texture = useLoader(THREE.TextureLoader, card.imagePath)

  const rotationSpeed = useMemo(() => Math.random() * 0.002 + 0.001, [])
  const initialRotation = useMemo(() => Math.random() * Math.PI * 2, [])
  const floatOffset = useMemo(() => Math.random() * Math.PI * 2, [])
  const floatSpeed = useMemo(() => Math.random() * 0.3 + 0.2, [])
  const floatAmplitude = useMemo(() => Math.random() * 0.4 + 0.2, [])

  useFrame((state) => {
    if (!meshRef.current) return
    const time = state.clock.getElapsedTime()

    // Smooth rotation
    meshRef.current.rotation.y = initialRotation + time * rotationSpeed
    meshRef.current.rotation.x = Math.sin(time * 0.5 + floatOffset) * 0.06
    meshRef.current.rotation.z = Math.cos(time * 0.3 + floatOffset) * 0.03

    // Float
    meshRef.current.position.y = card.position[1] + Math.sin(time * floatSpeed + floatOffset) * floatAmplitude

    // Drift
    meshRef.current.position.x -= card.speed
    if (meshRef.current.position.x < -50) {
      meshRef.current.position.x = 50
      meshRef.current.position.y = (Math.random() - 0.5) * 20
      meshRef.current.position.z = -Math.random() * 30 - 20
    }
  })

  const w = isMobile ? 1.6 : 2
  const h = isMobile ? 3.2 : 4

  return (
    <mesh ref={meshRef} position={card.position}>
      <boxGeometry args={[w, h, 0.02]} />
      <meshPhysicalMaterial
        map={texture}
        side={THREE.DoubleSide}
        transparent
        opacity={0.9}
        roughness={0.55}
        metalness={0}
        clearcoat={0.2}
        clearcoatRoughness={0.5}
      />
    </mesh>
  )
}
